<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard">
        <p-toast key="toastmsg"></p-toast>
        <div class="mainDivHeader">
            <div class="leftdiv">
                <h4>Income History<span class="badge">{{tournamentData.length}}</span></h4>
            </div>

            <div class="rightDiv">
            </div>
        </div>

        <div class="mainDivBody">
            <div class="date-filterDiv">
                <ul class="filtersList">
                    <li>
                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                            [(ngModel)]="startDate" class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy"
                            [showIcon]="true" placeholder="FROM: dd / mm / yy"></p-calendar>
                    </li>
                    <li>
                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                            [(ngModel)]="endDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
                            [showIcon]="true" placeholder="To: dd / mm / yy"></p-calendar>
                    </li>
                    <li>
                        <!-- <button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-" (click)="loadWallet($event)"></button> -->
                        <button (click)="tournamentIncomeHistory()" class="searchFilterBtn">
                            <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
                        </button>
                    </li>
                    <li>
                        <!-- <button pButton label="Clear Filters" class="p-button-outlined p-mr-2 p-mb-2" icon="pi pi-filter-slash" (click)="clear()"></button> -->
                        <button (click)="clear()" class="clearFilterBtn">
                            <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                            <span>Clear All</span>
                        </button>
                    </li>
                </ul>
            </div>

            <div class="maintableDiv">
                <div class="tableParanet">
                    <p-table [value]="tournamentData" dataKey="name" responsiveLayout="scroll" rowExpandMode="single">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Tournament Name </th>
                                <th>Location</th>
                                <th>Categories</th>
                                <th>Surface </th>
                                <th> Tournament Start Date </th>
                                <th>Total Amount </th>
                                <th> Status </th>
                                <th>Total Person </th>

                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-data let-expanded="expanded">
                            <tr [pRowToggler]="data" (click)="getTournamentCategory(data._id)" class="collapseTr">
                                <td>
                                    <button class="arrowbtn" pButton pRipple
                                        [icon]="expanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></button>
                                    {{data.name}}
                                </td>
                                <!-- <td><img [src]="'assets/showcase/images/demo/data/' + data.image"
                                                    [alt]="data.name" width="100" class="p-shadow-4" /></td> -->
                                <td>{{data.cityname}}</td>
                                <td>{{data.resultCat.length}}</td>
                                <td>{{data.court}}</td>

                                <td>{{data.startdate | date: 'MM/dd/yyyy'}}</td>
                                <td>{{data.total | currency:'INR'}}</td>
                                <td> <span style="color: green;">Finished</span> </td>
                                <td>{{data.result.length}}</td>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="rowexpansion" let-data>
                            <tr>
                                <td colspan="9" class="expanded-td">
                                    <div class="Top-filter-div d-flex p-p-3 justify-content-start ">
                                        <div class="dropdown-div p-mr-3">
                                            <label for="categoryType">Select Category: </label>&nbsp;
                                            <p-dropdown appendTo="body" [style]="{'width':'180px'}"
                                                inputId="categoryType" [options]="categoryList" [filter]="true"
                                                placeholder="Select Category" optionLabel="matchTypeName"
                                                [ngClass]="{ 'is-invalid': submitted && f.categoryType.errors }"
                                                (onChange)="onSelectCategory($event,data._id)"></p-dropdown>
                                            <div *ngIf="submitted && f.categoryType.errors.required"
                                                class="invalid-feedback">
                                                Please select Match type
                                            </div>
                                        </div>

                                        <div class="dropdown-div">
                                            <label for="ageGroup">Select Age Group: </label>&nbsp;
                                            <p-dropdown appendTo="body" [style]="{'width':'180px'}" inputId="ageGroup"
                                                [options]="ageGroupList" [filter]="true" placeholder="Select Age Group"
                                                optionLabel="ageGroupName"
                                                [ngClass]="{ 'is-invalid': submitted && f.ageGroup.errors }"
                                                (onChange)="onAgeGroupSelect($event,data._id)"></p-dropdown>
                                            <div *ngIf="submitted && f.ageGroup.errors.required"
                                                class="invalid-feedback">
                                                Please select Age Group
                                            </div>
                                        </div>
                                    </div>
                                    <div class="p-p-3 tableInner">
                                        <p-table [value]="playerdata" dataKey="id">
                                            <ng-template pTemplate="header">
                            <tr style="background: #a41c1c00 !important;">
                                <th style="background: #ffffff;border-bottom: 1px solid;">Transaction ID</th>
                                <th style="background: #ffffff;border-bottom: 1px solid;">Name </th>

                                <th style="background: #ffffff;border-bottom: 1px solid;">Fees</th>
                                <th style="background: #ffffff;border-bottom: 1px solid;">Status</th>
                                <!-- <th >Action</th> -->

                            </tr>
                        </ng-template>


                        <ng-template pTemplate="body" let-playerdata>

                            <tr>

                                <td>{{playerdata.playerDetails[0]['_id']}}</td>
                                <td class="capitalize">{{playerdata.playerDetails[0]['fullName']}}</td>
                                <td>{{playerdata.entryFee | currency:'INR'}}</td>
                                <td> <span style="color: green;">Paid</span></td>
                                <!-- <td><p-button type="button" icon="pi-ellipsis-v"></p-button></td> -->
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="summary" let-playerdata>
                            <div class="p-d-flex p-ai-center p-jc-between" *ngIf="!playerRegister">
                                No player found
                            </div>
                        </ng-template>


                    </p-table>
                </div>
                </td>
                </tr>
                </ng-template>

                </p-table>
            </div>
        </div>
    </div>


</div>
</div>